// extracted by mini-css-extract-plugin
module.exports = {"text":"PaymentMethodsStyle_text__1zgX0","title":"PaymentMethodsStyle_title__3bdkW","subtitle":"PaymentMethodsStyle_subtitle__3v_Lm"};